import AllergyPreferencesView from "./AllergyPreferencesView"
export default AllergyPreferencesView
